import React from 'react'
import Landing from '../routes/landings/Room'

const Room = () => {
  return <Landing />
}

export default Room
